import { Button } from '@mui/material';

import { CustomTooltip } from '@/components/custom-tooltip';
import { useOktaAuth } from '@okta/okta-react';
import { useUser } from 'features/users/context/userContext';
import { labels } from 'locales/en.label';

function UserDetails() {
	const userLabels = labels.header.user_details;
	const { oktaAuth } = useOktaAuth();
	const { isAuthenticated, user } = useUser();

	const login = () => {
		oktaAuth.signInWithRedirect();
	};

	const logout = async () => {
		await oktaAuth.signOut();
	};

	return (
		<div className={`user-details ${isAuthenticated ? 'user' : 'no-user'}`}>
			<CustomTooltip
				content={
					<p>
						{user ? `${userLabels.logout} (${user.name})` : userLabels.login}
					</p>
				}
				placement='bottom'
			>
				<Button className='login-btn' onClick={user ? logout : login}>
					<h5 className='user-details__name'>
						{user?.initials || userLabels.default_initials}
					</h5>
				</Button>
			</CustomTooltip>
		</div>
	);
}

export default UserDetails;
